import { isUndefined } from 'lodash-es';
import { ReactElement } from 'react';

import type { IntentProps } from '../../../../core/slots/Intent/Intent.js';
import { isValidColorRule } from '../../../core/slots/ColorRule.js';
import { extractBehaviorTrackingProps } from '../../../core/utils/extract-behavior-tracking-props.js';
import { MultiMeterBarChartSlots } from '../../multi-meter-bar/types/multi-meter-bar-chart-config.js';
import { MeterBarChartSlots } from '../../single-meter-bar/types/meter-bar-chart-config.js';

export function handleLabelSlot(
  child: ReactElement,
  slots: MeterBarChartSlots | MultiMeterBarChartSlots,
): void {
  slots.label = child.props.children;
}

export function handleValueSlot(
  child: ReactElement,
  slots: MeterBarChartSlots | MultiMeterBarChartSlots,
): void {
  slots.value = {
    value: child.props.children,
    auto: isUndefined(child.props.children),
  };
}

export function handleMinSlot(
  child: ReactElement,
  slots: MeterBarChartSlots | MultiMeterBarChartSlots,
): void {
  slots.min = {
    value: child.props.children,
    auto: isUndefined(child.props.children),
  };
}

export function handleMaxSlot(
  child: ReactElement,
  slots: MeterBarChartSlots | MultiMeterBarChartSlots,
): void {
  slots.max = {
    value: child.props.children,
    auto: isUndefined(child.props.children),
  };
}

export function handleColorRuleSlot(
  child: ReactElement,
  slots: MeterBarChartSlots | MultiMeterBarChartSlots,
): void {
  const colorRule = child.props;
  if (isValidColorRule(colorRule)) {
    slots.colorRules.push(colorRule);
  }
}

export function handleIntentSlot(
  child: ReactElement,
  intents: IntentProps[] | undefined,
): IntentProps[] {
  return intents ? [...intents, child.props] : [child.props];
}

export function handleToolbarSlot(
  child: ReactElement,
  slots: MeterBarChartSlots | MultiMeterBarChartSlots,
): void {
  if (slots.toolbar && 'hidden' in child.props) {
    slots.toolbar.hidden = child.props.hidden;
  }
  if (slots.toolbar) {
    Object.assign(slots.toolbar, extractBehaviorTrackingProps(child.props));
  }
}
